import ApplicationBenefits from './ApplicationBenefits'
import ApplicationNavigation from './ApplicationNavigation'
import SectionHeading from '../shared/SectionHeading'
import styles from './styles.module.scss'

const ApplicationSection = (): JSX.Element => (
  <section className={`${styles.block} ${styles.application}`} id="form">
    <div className={`${styles.content} ${styles.center}`}>
      <SectionHeading
        eyebrow="紹介キャンペーン受付フォーム"
        title="ecbo cloakと一緒に、地図を埋めよう"
        description="店舗を「紹介する」方も、ご自身のお店で「応募する」方も、こちらから。"
      />
    </div>
    <div className={`${styles.content} ${styles.applicationShell} ${styles.reveal}`} data-reveal="">
      <ApplicationBenefits />
      <ApplicationNavigation />
    </div>
  </section>
)

export default ApplicationSection
